@if (device$ | async; as device) {
  <div class="main-container">
    <app-card class="flex-2" [loading]="(loading$ | async) ?? false">
      <div class="header">
        <button type="button" class="button icon-button" (click)="onBack()">
          <app-icon name="ic_chevron_left" />
          <span class="hidden-on-mobile">{{ "default.back" | translate }}</span>
        </button>

        <div class="actions">
          <button type="button" class="button icon-button" (click)="onEdit()">
            <app-icon name="ic_edit" />
            {{ "default.edit" | translate }}
          </button>
          <button
            type="button"
            class="button icon-button"
            (click)="onToggleFavorite(device)"
          >
            @if (device.isFavorite) {
              <app-icon class="color-favorite" name="ic_star_filled" />
            } @else {
              <app-icon name="ic_star" />
            }
          </button>
          <app-context-menu [menuItems]="getContextMenu(device)" />
        </div>
      </div>

      <div class="flex gap-4">
        <h2>
          <app-text-with-icon [name]="device.type | icons">{{
            device.name
          }}</app-text-with-icon>
        </h2>
        @if (device.isOutOfService) {
          <app-tag class="ml-2" level="disabled">
            {{ "devices.detail.outOfService.label" | translate }}
          </app-tag>
        } @else if (device.isActuator) {
          @let isActive = (isActive$ | async) ?? false;
          @let killSwitch = (killSwitch$ | async) ?? false;
          @let isOutOfService = device.isOutOfService ?? false;
          <app-device-action-trigger
            [disabled]="
              isActive ? isOutOfService : isOutOfService || !killSwitch
            "
            size="lg"
            [isActive]="isActive"
            [isPending]="isDevicePending(device)"
            (triggerDeviceAction)="onTriggerDeviceAction($event.value)"
          />
        }
      </div>

      <section class="grid grid-cols-2 align-start">
        <app-device-info-table [device]="device" />

        <div>
          <section>
            <div class="flex gap-1 align-center mb-1">
              <p class="bold">
                {{ "pumps.detail.connectedValves" | translate }}
              </p>
              <button
                type="button"
                class="button icon-button small"
                [attr.aria-label]="
                  'pumps.detail.editConnectedValves' | translate
                "
                (click)="onEditConnectedValves()"
              >
                <app-icon name="ic_edit" />
              </button>
            </div>
            <div class="flex column gap-1 align-stretch">
              @for (valve of (connectedValves$ | async) ?? []; track valve.id) {
                <app-device-item-card
                  [device]="valve"
                  [description]="'pumps.detail.asSourcePump' | translate"
                />
              } @empty {
                <p>{{ "pumps.detail.noConnectedValves" | translate }}</p>
              }
            </div>
          </section>
        </div>
      </section>
    </app-card>

    @let isUsableInRule = (isUsableInRule$ | async) ?? false;
    @if (isUsableInRule) {
      <div class="flex-1 grid grid-cols-auto">
        <app-device-rules-card
          [rules]="(ruleList$ | async) ?? []"
          [disabled]="device.isOutOfService ?? false"
          (createRule)="onCreateRule()"
        />
      </div>
    }
  </div>

  <div class="detail-container">
    <app-map-with-location
      class="map-wrapper"
      [navigateToMaps]="true"
      [device]="getMapDevice(device)"
    />
    @if (isUsableInRule$ | async) {
      @if (history$ | async; as history) {
        <app-history
          class="flex-1"
          [history]="history.data"
          [loading]="history.loading"
          [canLoadMore]="history.canLoadMore"
          (loadMore)="onLoadMoreHistory()"
        />
      }
    }
  </div>
} @else {
  <app-not-found [error]="getError()" [loading]="(loading$ | async) ?? false" />
}
